// add-to-list-modal.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ListItem } from 'src/app/core/models/favoritesModals.model';
import { FunctionsService } from 'src/app/data/functions.service';

@Component({
  selector: 'app-add-to-list-modal',
  templateUrl: './add-to-list-modal.component.html',
  styleUrls: ['./add-to-list-modal.component.css']
})
export class AddToListModalComponent implements OnInit {
  @Input() productName = '';
  @Input() ean = '';
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() confirmSelection = new EventEmitter<{ description: string, name: string }[]>();
  @Output() createNewList = new EventEmitter<void>();

  @Input() lists: ListItem[] = [];
  favorites = [];
  originalLists = [];

  constructor(
    private functions: FunctionsService,
  ) { };

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.fetchLists();
  }

  goToListsLink() {
    return '/minha-conta/favoritos';
  }

  fetchLists() {
    this.functions.getFavorites().pipe(
      finalize(() => { })
    ).subscribe({
      next: (response) => {
        if (response.ok) {
          const { lists: listsResponse, favorites } = response.body.data;
          let id = 1
          console.log(this.ean)
          this.favorites = favorites;
          this.originalLists = listsResponse
          const favoritesIds = favorites.map(e => e.id)
          console.log(typeof this.lists)
          this.lists?.push({
            id: 1,
            name: 'Meus favoritos',
            description: 'Predeterminada',
            icon: '💙',
            selected: !!favoritesIds?.includes(this?.ean)
          });

          listsResponse.forEach((e) => {
            id += 1;
            const { image, name } = e
            this.lists.push({
              id, icon: image || null, name, description: 'Lista de produtos', selected: false,
            })
          })

        }
      },
      error(err) {

      },
    })
  }

  onClose() {
    this.closeModal.emit();
  }

  onConfirm() {
    const selectedLists = this.lists
      .filter(list => list.selected)
      .map(list => ({
        name: list.name,
        description: list.description
      }));

    this.confirmSelection.emit(selectedLists);
    this.onClose();
  }

  onCreateNewList() {
    this.createNewList.emit();
  }

  toggleSelection(listId: number) {
    const list = this.lists.find(l => l.id === listId);
    if (list) {
      list.selected = !list.selected;
    }
  }

  getSelectedCount(): number {
    return this.lists.filter(list => list.selected).length;
  }
}
